import { history, persistor, store } from '@/redux/store'
import { GlobalStyles, createMuiTheme } from '@/theme'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import React from 'react'
import { Provider } from 'react-redux'
import { HistoryRouter as Router } from 'redux-first-history/rr6'

import { PersistGate } from 'redux-persist/integration/react'

import { BrowserRouter, Route, Routes } from 'react-router-dom'
import GlobalSnackbar from './components/GlobalSnackbar'
import LogoutModal from './components/LogoutModal'
import AppRoutes from './routes'
import Env from './config/Env'
import ForbiddenModal from './components/ForbiddenModal'

const App = () => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')

  const theme = React.useMemo(
    () =>
      createMuiTheme({
        mode: prefersDarkMode ? 'light' : 'light',
      }),
    [prefersDarkMode],
  )

  const urlPrefix = Env.URL_PREFIX

  return (
    <>
      {/* Redux provider, we pass in our redux store here */}
      <Provider store={store}>
        {/* Redux persist */}
        <PersistGate loading={null} persistor={persistor}>
          {/* MUI theme provider, we pass in our custom theme here */}
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <GlobalStyles />

            {/* Our main app router */}
            <Router history={history} basename={urlPrefix}>
              <AppRoutes />
            </Router>

            {/* If a url prefix is set (refer to .env file REACT_APP_URL_PREFIX field), */}
            {/* redirect app to base url with prefix appended IF prefix is not already present is current url  */}
            {/* e.g. REACT_APP_URL_PREFIX="myprefix" */}
            {/* Current url: https://localhost:3000/ */}
            {/* Redirects to: https://localhost:3000/myprefix */}
            {urlPrefix && (
              <BrowserRouter>
                <Routes>
                  <Route path={`/${urlPrefix}/*`} />
                  <Route exact path="/*" element={<BaseRedirect urlPrefix={urlPrefix} />} />
                </Routes>
              </BrowserRouter>
            )}

            <GlobalSnackbar />
            <LogoutModal />
            <BrowserRouter>
              <ForbiddenModal />
            </BrowserRouter>
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </>
  )
}

const BaseRedirect = ({ urlPrefix }) => {
  window.location = `/${urlPrefix}`
}

export default App
